import { render, staticRenderFns } from "./orderother.vue?vue&type=template&id=1de43b50&"
import script from "./orderother.vue?vue&type=script&lang=js&"
export * from "./orderother.vue?vue&type=script&lang=js&"
import style0 from "./orderother.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports